import styled from 'styled-components';

export const Container = styled.section`
  border-radius: 4px;
  display: flex;
  font-family: 'Oswald', sans-serif;
  font-size: 42px;
`;
Container.displayName = 'Container';

export const PlayerDivider = styled.div`
  padding: 0 8px;
`;
PlayerDivider.displayName = 'PlayerDivider';

export const PlayerOne = styled.div`
  margin-left: 50px;
  &:before {
    content: ${({ isServing }) => (isServing ? `"●"` : '')};
    position: absolute;
    top: -5px;
    left: 15px;
  }
`;
PlayerOne.displayName = 'PlayerOne';

export const PlayerTwo = styled.div`
  margin-right: 50px;
  &:after {
    content: ${({ isServing }) => (isServing ? `"●"` : '')};
    position: absolute;
    top: -5px;
    right: 15px;
  }
`;
PlayerTwo.displayName = 'PlayerTwo';

export const Points = styled.div`
  font-weight: bold;
  min-height: 63px;
  min-width: 72px;
  text-align: center;

  &:first-child {
    border-radius: 0 4px 0 0;
  }
  &:last-child {
    border-radius: 0 0 4px 0;
  }
`;
Points.displayName = 'Points';

export const PointsContainer = styled.div`
  background-color: #ccc;
  border-radius: 0 4px 4px 0;
  color: #000;
  display: flex;
  flex-direction: column;
`;
PointsContainer.displayName = 'PointsContainer';

export const Set = styled.div`
  min-width: 72px;
  text-align: center;
`;
Set.displayName = 'Set';

export const SetContainer = styled.div`
  background-color: #eee;
  border-left: 1px solid #333;
  color: #000;
  display: flex;
  flex-direction: column;
`;
SetContainer.displayName = 'SetContainer';

export const TeamNameContainer = styled.div`
  border-radius: 4px 0 0 4px;
  display: flex;
  flex-direction: column;
`;
TeamNameContainer.displayName = 'TeamNameContainer';

export const TeamName = styled.div`
  background-color: #333;
  color: #fff;
  display: flex;
  justify-content: center;
  min-width: 200px;
  position: relative;
  text-align: center;

  &:first-child {
    border-radius: 4px 0 0 0;
  }
  &:last-child {
    border-radius: 0 0 0 4px;
  }
`;
TeamName.displayName = 'TeamName';

export const Timer = styled.div`
  align-items: center;
  background-color: #333;
  color: #fff;
  display: flex;
  justify-content: center;
  min-width: 130px;
  padding: 0 16px;
  text-align: center;

  &:first-child {
    border-radius: 4px 0 0 4px;
  }
`;
Timer.displayName = 'Timer';
